import React, { useEffect, useState } from 'react'
import { RenderDialogProps } from '../../../legacy-design-system/action/confirmation-action'
import { ConfirmationDialog } from '../../../legacy-design-system/modal'
import { ApplicationActionProps } from './row-action-list'
import { FormattedMessage } from 'react-intl'
import { ShowAsyncResetApplicationToast } from '../show-async-reset-application-toast'

interface ResetDialogProps extends RenderDialogProps {
  applicationName: string
  onClick: () => void
  className?: string
}

export function ConfirmResetAppDialog({
  isOpen,
  closeDialog,
  applicationName,
  onClick,
  className
}: ResetDialogProps) {
  const strongRenderer = (chunks) => <strong>{chunks}</strong>
  const pRenderer = (chunks) => <p>{chunks}</p>

  return (
    <ConfirmationDialog
      size="small"
      isOpen={isOpen}
      onCancel={closeDialog}
      className={className}
      onConfirm={() => {
        onClick()
      }}
      renderConfirmMessage={() => (
        <FormattedMessage
          id="action_applications_reset_application"
          defaultMessage="Reset"
        />
      )}
      renderCancelMessage={() => (
        <FormattedMessage id="action_cancel" defaultMessage="Cancel" />
      )}
      renderTitle={() => (
        <FormattedMessage
          id="title_applications_resetApplication"
          defaultMessage="Reset Application"
        />
      )}
      renderBody={() => (
        <FormattedMessage
          id="detail_applications_resetApplicationConfirmation"
          values={{
            applicationName,
            strong: strongRenderer,
            p: pRenderer
          }}
        />
      )}
    />
  )
}

export function ResetDialog({
  application: { id: applicationID, name: applicationName },
  organizationID,
  className,
  ...props
}: RenderDialogProps & ApplicationActionProps) {
  const [doAsyncResetApplication, setDoAsyncResetApplication] = useState(false)
  const { closeDialog } = props

  useEffect(() => {
    if (doAsyncResetApplication) {
      setDoAsyncResetApplication(false)
      closeDialog()
    }
  }, [doAsyncResetApplication, closeDialog])

  return (
    <>
      <ConfirmResetAppDialog
        {...props}
        applicationName={applicationName}
        className={className}
        onClick={() => {
          setDoAsyncResetApplication(true)
        }}
      />
      {doAsyncResetApplication && (
        <ShowAsyncResetApplicationToast
          organizationID={organizationID}
          applicationID={applicationID}
        />
      )}
    </>
  )
}
